import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash.get';

import { loadMenu } from 'redux/modules/menu';
import { menuItem as menuItemPropType } from 'lib/CustomPropTypes';

import Link from 'components/Link';
import ButtonHoverAnimation from 'components/ButtonHoverAnimation';
import parseIdFromUrl from 'lib/parseIdFromUrl';

const mapStateToProps = ({ article, menu, shared }) => ({
  articleId: article.content && article.content[0] && article.content[0].id,
  menu: menu.current,
  vertical: shared.vertical,
});

const mapActionsToProps = (dispatch) => ({
  loadEmbedMenu: (id) => dispatch(loadMenu(id)),
});

@connect(mapStateToProps, mapActionsToProps)
class MenuEmbed extends React.Component {
  static propTypes = {
    articleId: PropTypes.string,
    html: PropTypes.string,
    menu: PropTypes.shape({
      name: PropTypes.string,
      id: PropTypes.string,
      menuItems: PropTypes.arrayOf(menuItemPropType),
    }),
    loadEmbedMenu: PropTypes.func,
    className: PropTypes.string,
    vertical: PropTypes.string.isRequired,
  };

  static defaultProps = {
    articleId: '',
    html: null,
    menu: {},
    loadEmbedMenu: () => {},
    className: 'menu-embed',
  };

  componentDidMount() {
    const { html, loadEmbedMenu } = this.props;
    const menuId = this.getMenuId(html);
    loadEmbedMenu(menuId);
  }

  getMenuId = (html) => {
    const { vertical } = this.props;
    const match = html.match(/embedId=["“”]([0-9]+)["“”]/);
    const menuId = match && match[1];

    if (!menuId) return null;

    return vertical === 'today' ? `tdmn${menuId}` : `ncmn${menuId}`;
  };

  appendUrlTracking = (url) => (
    `${url}${url.indexOf('?') === -1 ? '?' : '&'}cid=menu`
  );

  renderMenuItems = (menuItems) => (
    menuItems.map((item, i) => {
      const { articleId } = this.props;

      const url = get(item, 'url.primary', null);
      const linkId = parseIdFromUrl(url);
      const { text = '' } = item;

      if (articleId === linkId) return null;

      if (i > 6) return null;

      if (i === 6) {
        return this.renderSeeMoreButton(url, i);
      }

      return (
        <li className="menu-embed__link" key={`${i + url}`}>
          <Link href={this.appendUrlTracking(url)}>
            { /* 100 char max */}
            {text.slice(0, 100)}
          </Link>
        </li>
      );
    })
  )

  renderSeeMoreButton = (url, i) => (
    <ButtonHoverAnimation
      key={i + url}
      size="normal"
      type="link"
      url={url}
      title="See More"
    />
  );

  render() {
    const { menu, className } = this.props;
    const { name = '', menuItems = [] } = menu || {};

    // 30 char max
    const shortenedTitle = name.slice(0, 30);

    return menuItems.length ? (
      <div className={className}>
        <h4 className="menu-embed__title">
          {shortenedTitle}
        </h4>
        <ul className="menu-embed__items">
          {this.renderMenuItems(menuItems)}
        </ul>
      </div>
    ) : null;
  }
}

export default MenuEmbed;
